define('lib/Podio.UI.Tasks.Form',['require','underscore','jquery','jquery-ui','lib/jquery/jquery.podioDropdown','lib/jquery/jquery.timeentry','translate','root/tasks/Podio.Transport.Tasks','lib/Podio.UI.Reminder','lib/Podio.UI.Recurrence','lib/Podio.UI.PeoplePicker','lib/Podio.Store','lib/jquery/jquery.podiopicker','lib/Podio.Transport.Picker','lib/Podio.Utils'],function (require) {

  var _ = require('underscore');
  var $ = require('jquery');
  require('jquery-ui');
  require('lib/jquery/jquery.podioDropdown');
  require('lib/jquery/jquery.timeentry');
  var t = require('translate');

  var TasksTransport = require('root/tasks/Podio.Transport.Tasks');
  var Reminder = require('lib/Podio.UI.Reminder');
  var Recurrence = require('lib/Podio.UI.Recurrence');
  var PeoplePicker = require('lib/Podio.UI.PeoplePicker');
  var PodioStore = require('lib/Podio.Store');

  var PodioPicker = require('lib/jquery/jquery.podiopicker');
  var transportPicker = require('lib/Podio.Transport.Picker');
  var podioUtils = require('lib/Podio.Utils');

  var responsiblePodioPickerOptions = {
    initialFocusInInput: false,
    allowFreeTokens: false,
    prePopulate : null,
    inputTokenIcon: 'icon-user',
    classes: {
      tokenList: 'token-input-list fluid people-picker responsible-picker'
    }
  };

  var dataStore = PodioStore.create('tasks');
  var dataStoreLabelKey = 'task-labels';

  function setupResponsible(elmResponsible, extraPodioPickerOptions, getSpaceIdCallback) {
    var contact_ids = elmResponsible.val() !== '' ? elmResponsible.val().split(',') : [];
    var intContactIds = _.compact(_.map(contact_ids, function(value) {
      var result = parseInt(value, 10);
      return !isNaN(result) ? result : null;
    }));

    if (window.gadgets) {
      setupPodioPicker(elmResponsible, extraPodioPickerOptions, getSpaceIdCallback, intContactIds);
    } else {
      setupPeoplePicker(elmResponsible, extraPodioPickerOptions, getSpaceIdCallback, intContactIds);
    }
  }

  function setupPodioPicker(elmResponsible, extraPodioPickerOptions, getSpaceIdCallback, intContactIds) {
    var currentPodioPickerOptions = $.extend({
      onDataRequest: getContactsData.curry(getSpaceIdCallback),
      placeholderText: elmResponsible.attr('placeholder')
    }, responsiblePodioPickerOptions);

    if(extraPodioPickerOptions) {
      currentPodioPickerOptions = $.extend(currentPodioPickerOptions, extraPodioPickerOptions);
    }

    if(_.isArray(intContactIds) && intContactIds.length) {
      transportPicker.getContactsData('single_user', intContactIds, function(responseData) {
        currentPodioPickerOptions.prePopulate = responseData;
        elmResponsible.podioPicker(currentPodioPickerOptions);
      });
    } else {
      elmResponsible.podioPicker(currentPodioPickerOptions);
    }
  }

  function setupPeoplePicker(elmResponsible, extraPodioPickerOptions, getSpaceIdCallback, intContactIds) {
    var initPeoplePicker = function(elmTarget, options) {
      options.podioPickerOptions.allowFreeTokens = true; // Force allowFreeTokens when using PeoplePicker
      return new PeoplePicker(elmTarget, 'task_responsible', options);
    };

    var options = _.extend({
      podioPickerOptions : $.extend(responsiblePodioPickerOptions, extraPodioPickerOptions)
    }, extraPodioPickerOptions);

    if(_.isArray(intContactIds) && intContactIds.length) {
      transportPicker.getContactsData('single_user', intContactIds, function(responseData) {
        options.prePopulate = responseData;
        initPeoplePicker(elmResponsible, options);
      });
    } else {
      initPeoplePicker(elmResponsible, options);
    }
  }

  var labelsPodioPickerOptions = {
    initialFocusInInput: false,
    allowFreeTokens: true,
    prePopulate : null,
    tokenLimit: null,
    inputTokenIcon: 'icon-task-label',
    noResultsText: t("No labels found #tasks"),
    classes: { tokenList: 'token-input-list label-picker fluid' }
  };

  function setupLabelList(elmLabelList, extraPodioPickerOptions) {
    var currentPodioPickerOptions = $.extend({
      placeholderText: elmLabelList.attr('placeholder'),
      onDataRequest: getLabelData.curry(elmLabelList),
      direction: window.location != window.parent.location ? 'top' : 'bottom'
    }, labelsPodioPickerOptions);
    if(extraPodioPickerOptions) {
      currentPodioPickerOptions = $.extend(currentPodioPickerOptions, extraPodioPickerOptions);
    }

    var label_ids = elmLabelList.val() !== '' ? elmLabelList.val().split(',') : [];

    if(label_ids.length > 0) {
      getLabelData(elmLabelList, 'single', label_ids, function(labels) {
        currentPodioPickerOptions.prePopulate = labels;
        elmLabelList.podioPicker(currentPodioPickerOptions);
      });
    } else {
      elmLabelList.podioPicker(currentPodioPickerOptions);
    }
  }

  function setupDueDate(elmDueDateSelect, elmDueDateInputField) {
    elmDueDateSelect.bind('change.dropdown.podio', function(e, selectedValue) {
      if(selectedValue == 'custom-date') {
        onCustomDateClicked(elmDueDateSelect, elmDueDateInputField);
      } else {
        elmDueDateInputField.val(selectedValue);
      }
    });
    elmDueDateSelect.podioDropdown({
      textFormatFunction: dueDateDropdownTextFormat,
      matchTextFieldHeight: true
    });

    elmDueDateInputField.datepicker({
      dateFormat: $.datepicker.ISO_8601,
      showOtherMonths: true,
      selectOtherMonths: true,
      beforeShow: function(event){
        _.defer(function() {
          $('.ui-datepicker').css("z-index", 99999);
        });
      },
      onClose: onCustomDateSelected.curry(elmDueDateSelect, elmDueDateInputField)
    });
  }

  function setupSpacePicker(elmSpacePicker, options, elmPrivate) {
    var pickerOptions = $.extend({
      showTopList: true,
      tokenLimit: 1,
      onDataRequest: transportPicker.getSpaceAndItemsData,
      hintText: elmSpacePicker.attr('placeholder'),
      onTokenAdded: onSpacePickerTokenAdded.curry(elmPrivate),
      onTokenRemoved: onSpacePickerTokenRemoved.curry(elmPrivate),
      direction: window.location != window.parent.location ? 'top' : 'bottom',
      placeholderText: t('Type in to search for spaces or app items #tasks')
    }, options);

    elmSpacePicker.podioPicker(pickerOptions);
  }

  function onSpacePickerTokenAdded(elmPrivate, elmSpacePicker, token) {
    if(elmPrivate) {
      enableSharingDropdown(elmPrivate);
    }

    elmSpacePicker.parents('.space-reference:first').find('#task_ref_type').val(token.ref_type);

    return true;
  }

  function onSpacePickerTokenRemoved(elmPrivate, elmSpacePicker, token) {
    if(elmPrivate) {
      disableSharingDropdown(elmPrivate);
    }

    elmSpacePicker.parents('.space-reference:first').find('#task_ref_type').val('');

    return true;
  }

  function disableSharingDropdown(elmPrivate) {
    elmPrivate.trigger('disable.dropdown.podio');
    elmPrivate.val('true');
    elmPrivate.prop('disabled', true);
    elmPrivate.trigger('refresh.dropdown.podio');
  }

  function enableSharingDropdown(elmPrivate) {
    elmPrivate.trigger('enable.dropdown.podio');
    elmPrivate.val('false');
    elmPrivate.prop('disabled', false);
    elmPrivate.trigger('refresh.dropdown.podio');
  }

  function setupPrivate(elmPrivate) {
    elmPrivate.podioDropdown({isDisabled: elmPrivate.is(':disabled'), matchTextFieldHeight: true });
  }

  function onCustomDateClicked(elmDueDateSelect, elmDueDateInputField) {
    var elmDueDateDropdown = elmDueDateSelect.next('div').children('.podio-dropdown-selector-wrapper');
    var dueDateOffset = elmDueDateDropdown.offset();
    dueDateOffset.top += elmDueDateDropdown.height() + 5;
    var elmDatePickerWidget = elmDueDateInputField.datepicker('widget');
    elmDueDateInputField.datepicker('show');
    elmDatePickerWidget.offset(dueDateOffset);
  }

  function onCustomDateSelected(elmDueDateSelect, elmDueDateInputField, selectedValue, elmDatePicker) {
    var elmDueDateDropdownText = elmDueDateSelect.next('div').children('.podio-dropdown-selector-wrapper').find('.podio-dropdown-text');
    var selectedDateLocalized = localizeISODate(selectedValue);
    elmDueDateDropdownText.text(selectedDateLocalized);
    elmDueDateSelect.trigger('change.dropdown.podio', selectedValue);
  }

  function dueDateDropdownTextFormat(elmOptions, menuOptions) {
    var selectedOption = elmOptions.filter(':selected');
    if(!selectedOption.length) {
      selectedOption = elmOptions.first();
    }

    var selectedDateISO = selectedOption.val();
    if(podioUtils.isPresent(selectedDateISO) && selectedDateISO != 'custom-date') {
      return localizeISODate(selectedDateISO);
    } else {
      return selectedOption.text();
    }

  }

  function localizeISODate(selectedDateISO) {
    var selectedDate = $.datepicker.parseDate($.datepicker.ISO_8601, selectedDateISO);
    var selectedDateLocalized = $.datepicker.formatDate($.datepicker._defaults.dateFormat, selectedDate);
    return selectedDateLocalized;
  }

  // When task_share feature is cleaned out, most of this method can be removed
  // The space_id stuff is not used anymore, but the single_user case is still used
  function getContactsData(getSpaceIdCallback, mode, query, callback) {
    var refType = $('#task_ref_type').val();
    var task_space_id = getSpaceIdCallback();
    var space_navigation = $('#space-navigation');
    var onSpace = (refType == 'space' || refType == 'app' || refType == 'item' || podioUtils.isPresent(task_space_id) || (space_navigation.length && ! $('#new_task').length));
    var taskMode;
    switch(mode) {
      case 'toplist':
        taskMode = 'toplist_task';
        break;
      case 'single':
        taskMode = 'single_user';
        break;
      default:
        taskMode = 'task';
        break;
    }
    if(onSpace) {
      var space_id;
      if(podioUtils.isPresent(task_space_id)) {
        space_id = task_space_id;
      }
      else if(refType == 'space' && (!$('.space-reference').length || $('.space-reference:visible').length == 1) ) {
        space_id = $('#task_ref_id').val();
      } else {
        space_id = space_navigation.data('space-id');
      }
      return transportPicker.getContactsDataOnSpace(taskMode, query, space_id, callback);
    } else {
      return transportPicker.getContactsData(taskMode, query, callback);
    }
  }

  function getSpacePickerData(mode, query, callback) {
    return transportPicker.getSpacePickerData(callback);
  }

  function getLabelData(elmLabelList, mode, query, callback) {
    var labels = dataStore.get(dataStoreLabelKey);
    if(!labels) {
      labels = elmLabelList.data('all-labels') || $('#task_label_list').data('all-labels');
      dataStore.store(dataStoreLabelKey, labels);
    }

    if(mode == 'single') {
      labels = labels.filter(function(current, index, all) {
        return query.indexOf(current.id.toString()) > -1;
      });
    } else {
      if(!query.isEmpty()) {
        labels = labels.filter(function(current, index, all) {
          return current.name.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      }
    }
    callback.apply(this, [labels]);
  }

  function invalidateLabelCache() {

    TasksTransport.getTaskLabels(function(responseData) {
      dataStore.clear(dataStoreLabelKey);
      dataStore.store(dataStoreLabelKey, responseData.data.task_labels, {update : true});
    });

  }

  function setupReminder(elmAnchor, elmDueDateInputField, elmDueDateSelect, elmDueOnTime, valueFieldExpression, elmReminderEnabled) {
    var currentDateTime = getCurrentDateTime(elmDueDateInputField);
    var reminder = Reminder.init(elmAnchor, valueFieldExpression, { 'currentDateTime': currentDateTime, 'elmReminderEnabled': elmReminderEnabled });
    elmDueDateSelect.bind('change.dropdown.podio', notifyInstanceThatDueDateChanged.curry(reminder, elmDueDateInputField, elmDueOnTime));
    elmDueOnTime.bind('change', notifyInstanceThatDueDateChanged.curry(reminder, elmDueDateInputField, elmDueOnTime));
    return reminder;
  }

  function setupRecurrence(elmAnchor, elmDueDateInputField, elmDueDateSelect, elmDueOnTime, valueFieldExpression, elmRecurrenceEnabled) {
    var currentDateTime = getCurrentDateTime(elmDueDateInputField);
    var recurrence = Recurrence.init(elmAnchor, valueFieldExpression, { 'currentDateTime': currentDateTime, 'elmRecurrenceEnabled': elmRecurrenceEnabled });
    elmDueDateSelect.bind('change.dropdown.podio', notifyInstanceThatDueDateChanged.curry(recurrence, elmDueDateInputField, elmDueOnTime));
    elmDueOnTime.bind('change', notifyInstanceThatDueDateChanged.curry(recurrence, elmDueDateInputField, elmDueOnTime));
    return recurrence;
  }

  function notifyInstanceThatDueDateChanged(instance, elmDueDateInputField, elmDueOnTime, e, selectedValue) {
    if(selectedValue != 'custom-date') {
      var currentDateTime = getCurrentDateTime(elmDueDateInputField, elmDueOnTime);
      instance.dateTimeChanged(currentDateTime);
    }
  }

  function getCurrentDateTime(elmDueDateInputField, elmDueOnTime) {
    var currentDateText = elmDueDateInputField.val();
    if(currentDateText && currentDateText !== '') {
      var date = $.datepicker.parseDate('yy-mm-dd', currentDateText);
      var time = elmDueOnTime ? $.timeEntry._getTimeTimeEntry(elmDueOnTime[0]) : null;
      var dateTime;
      if(time) {
        dateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds());
      } else {
        dateTime = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0); // Tasks without time defaults to 00:00:00
      }
      return dateTime;
    } else {
      return null;
    }
  }

  return {
    setupResponsible: setupResponsible,
    setupDueDate: setupDueDate,
    setupPrivate: setupPrivate,
    setupSpacePicker: setupSpacePicker,
    setupLabelList: setupLabelList,
    setupReminder: setupReminder,
    setupRecurrence: setupRecurrence,
    localizeISODate: localizeISODate,
    invalidateLabelCache: invalidateLabelCache,
    disableSharingDropdown: disableSharingDropdown,
    enableSharingDropdown: enableSharingDropdown,

    dueDateDropdownTextFormat: dueDateDropdownTextFormat,
    onCustomDateClicked: onCustomDateClicked,
    onCustomDateSelected: onCustomDateSelected,
    getCurrentDateTime: getCurrentDateTime
  };

});

